module.exports = __webpack_public_path__ + "images/stickers/taco-celebrate@2x.905a89b9fb1f86774713.png";